import { FreeformCanvas } from "./FreeFormCanvas";
import { OtherQuizSection } from "./OtherQuizSection";

/**
 * "Other" slide editor: the freeform drag-and-drop canvas, plus (below it) the post-content
 * sub-quiz authoring panel. Kept separate from `FreeformCanvas` itself since that component is
 * also reused for word+meaning canvas slides, which never have `subQuizzes`.
 */
export function OtherCanvasEditor() {
  return (
    <div className="flex flex-col gap-3">
      <FreeformCanvas />
      <OtherQuizSection />
    </div>
  );
}
